import angular from 'angular';
import ngMessages from 'angular-messages';

import {SignupService} from './signup.service';
import {SignupComponent} from './signup.component';

export const SignupModule = angular
        .module('mmsApp.pages.signup', [
            ngMessages
        ])
        .config(($stateProvider, $urlRouterProvider) => {
            'ngInject';
            $stateProvider
                .state('pages.signup', {
                    data: {
                        isAuthRequired: false,
                    },
                    params: {
                        user: {}
                    },
                    component: SignupComponent.name,
                    resolve: {
                        user: ($transition$) => {
                            return $transition$.params().user;
                        },
                        onSignup: ($transition$, UtilService) => {
                            return () => {
                                UtilService.redirectBackToPrev($transition$, 'pages');
                            };
                        }
                    }
                });
        })
        .service('SignupService', SignupService)
        .component(SignupComponent.name, SignupComponent.component)
        .name
    ;


// WEBPACK FOOTER //
// ./src/app/pages/signup/signup.module.js